import { prefsStore } from '@/app/preferences/prefsStore'
import type { TabKind } from './appWorkspaceStore'

export interface PersistedTab {
  path: string
  kind: TabKind
  title: string
}

export interface TabSession {
  tabs: PersistedTab[]
  activePath: string | null
}

export function sessionKey(connectionId: string): string {
  return `app_tabs:${connectionId}`
}

function isPersistedTab(v: unknown): v is PersistedTab {
  if (!v || typeof v !== 'object') return false
  const t = v as Partial<PersistedTab>
  return (
    typeof t.path === 'string' &&
    typeof t.title === 'string' &&
    (t.kind === 'list' || t.kind === 'record' || t.kind === 'report' || t.kind === 'mail')
  )
}

function isTabSession(v: unknown): v is TabSession {
  if (!v || typeof v !== 'object') return false
  const s = v as Partial<TabSession>
  if (!Array.isArray(s.tabs)) return false
  if (!(s.activePath === null || typeof s.activePath === 'string')) return false
  return s.tabs.every(isPersistedTab)
}

/** Corrupt / wrong shape → null (caller treats as empty). */
export function loadTabSession(connectionId: string): TabSession | null {
  try {
    const raw = prefsStore.getItem(sessionKey(connectionId))
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    return isTabSession(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function saveTabSession(connectionId: string, session: TabSession): void {
  try {
    prefsStore.setItem(sessionKey(connectionId), JSON.stringify(session))
  } catch {
    /* private browsing / quota */
  }
}
